<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" id="cover">
<img alt="Her Best Friend’s Husband" class="cover-image" role="doc-cover" src="images/her-best-friends-husband-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?b4bd4be8